export default "__VITE_ASSET__DKTtIEJG__"